// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_table {
  width: 100%;
  display: flex;
}

.caixas_tabela {
  border: 2px solid var(--cor-roxoTabela);
  background-color: #fff;
}

.caixas_tabela th {
  color: var(--cor-roxoEscuro);
  padding: 1em;
  text-align: left;
  font-weight: 600;
}


.caixas_tabela td {
  color: var(--cor-pretoApoio);
  padding: 10px;
  text-align: left;
  border: none;
}

.primeiros_colocados,
.outros_colocados,
.ultimos_colocados,
.ultimo {
  color: var(--cor-branco);
  font-weight: bold;
  width: 16px;
  max-height: 22px;
  border-radius: 5px;
  padding: 8px;
  text-align: center;
  font-size: 17px;
}

.primeiros_colocados {
  background-color: var(--cor-roxoEscuro);
  display: flex;
}

.outros_colocados {
  background-color: var(--cor-roxoColocados);
}


.ultimos_colocados {
  background-color: var(--cor-roxoUltimosColocados);
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}

.trofeu_ouro,
.trofeu_bronze,
.trofeu_prata {
  padding: 0 2em;
  width: 2em;
  height: 2em;
  object-fit: contain;
  vertical-align: middle;
}


.caixas_tabela tr:nth-child(even) {
  background-color: var(--cor-cinzaLinhaTabela);
}
`, "",{"version":3,"sources":["webpack://./src/tabelas/TabelaRanking.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;EACE,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;;EAIE,wBAAwB;EACxB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;;AAGA;EACE,iDAAiD;EACjD,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;;AAGA;EACE,6CAA6C;AAC/C","sourcesContent":[".container_table {\n  width: 100%;\n  display: flex;\n}\n\n.caixas_tabela {\n  border: 2px solid var(--cor-roxoTabela);\n  background-color: #fff;\n}\n\n.caixas_tabela th {\n  color: var(--cor-roxoEscuro);\n  padding: 1em;\n  text-align: left;\n  font-weight: 600;\n}\n\n\n.caixas_tabela td {\n  color: var(--cor-pretoApoio);\n  padding: 10px;\n  text-align: left;\n  border: none;\n}\n\n.primeiros_colocados,\n.outros_colocados,\n.ultimos_colocados,\n.ultimo {\n  color: var(--cor-branco);\n  font-weight: bold;\n  width: 16px;\n  max-height: 22px;\n  border-radius: 5px;\n  padding: 8px;\n  text-align: center;\n  font-size: 17px;\n}\n\n.primeiros_colocados {\n  background-color: var(--cor-roxoEscuro);\n  display: flex;\n}\n\n.outros_colocados {\n  background-color: var(--cor-roxoColocados);\n}\n\n\n.ultimos_colocados {\n  background-color: var(--cor-roxoUltimosColocados);\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.trofeu_ouro,\n.trofeu_bronze,\n.trofeu_prata {\n  padding: 0 2em;\n  width: 2em;\n  height: 2em;\n  object-fit: contain;\n  vertical-align: middle;\n}\n\n\n.caixas_tabela tr:nth-child(even) {\n  background-color: var(--cor-cinzaLinhaTabela);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
